export const SCAN_IN_PROGRESS_MESSAGE = "A scan is already in progress";
